import type { ListResponseOverrideReasonData } from "@classes-service-types/list-response-override-reason-data.ts";
import type { OverrideReasonDB } from "@classes-service-types/override-reason-db.ts";
import { useGetOverrideReasons } from "@/providers/overrideReasons/useGetOverrideReasons.ts";

export interface overrideReasons {
  reasonToLibraryIdMap: Map<string, Set<string>>;
  libraryToReasonIdMap: Map<string, Set<string>>;
  overrideReasonsOptions: Array<OverrideReasonDB>;
}

export const useOverrideReasons = () => {
  return useGetOverrideReasons<overrideReasons>({
    useQueryOptions: {
      select: (data: ListResponseOverrideReasonData) => {
        const retVal: overrideReasons = {
          reasonToLibraryIdMap: new Map<string, Set<string>>(),
          libraryToReasonIdMap: new Map<string, Set<string>>(),
          overrideReasonsOptions: [],
        };
        data?.items?.forEach((item) => {
          retVal.overrideReasonsOptions.push(item);
          if (!retVal.reasonToLibraryIdMap.has(item?.id)) {
            retVal.reasonToLibraryIdMap.set(item.id, new Set<string>());
          }
          item.skus?.forEach((sku) => {
            retVal.reasonToLibraryIdMap.get(item.id)?.add(sku.library_id);

            if (!retVal.libraryToReasonIdMap.has(sku?.library_id)) {
              retVal.libraryToReasonIdMap.set(sku.library_id, new Set<string>());
            }

            retVal.libraryToReasonIdMap.get(sku.library_id)?.add(item.id);
          });
        });
        retVal.overrideReasonsOptions?.sort((a, b) => a?.name.localeCompare(b?.name));
        return retVal;
      },
    },
  });
};
